import styled from '@emotion/styled';
import { Label, PageHeader, UpperInfoContainer } from 'components/PageLayout';
import { useParams } from 'react-router-dom';
import { CoveaReportArchived } from './Covea';
import { NPSBilling } from './NPSBilling';
import { BackButton } from 'components/Button';
import { Container, GridItem } from 'components/Layout';
import { Heading } from 'components/Typography';
import { TotalLossArchived } from './TotalLoss';
import { GoodWillReportArchived } from './Goodwill';
import { InvoiceExtractArchived } from './InvoiceExtract';
import { SLAPerformanceV3Archived } from './SLAPerformanceV3';
import { DetailedCycleTimeReportArchived } from './DetailedCycleTime';
import { SMSBillingReport } from './SMSBillling';
import { SMSReportArchived } from './SMSReport';
import { Rolling30DayReportArchived } from './Rolling30DayReport';
import { WorkInProgressArchived } from './WorkInProgress';
import { B2BRestMessagesReportArchived } from './B2BRestMessages';
import { VehiclesOnSiteArchived } from './VehiclesOnSite';
import { NargControlSheetV5Archived } from './NARGControl';
import { NPSSummaryReportArchived } from './NPS Summary Report';
import { NPSDetailV4Archived } from './NPSDetailV4';
import PrimaryToast from 'components/PrimaryToast';
import { useState } from 'react';
import { ActiveWebUsageV2Archived } from './ActiveWeb Usage Report';
import { AllSitesConnectionReportArchived } from './All Site Connections';
import { FeedbackReportArchived } from './Feedback Report';
import { LVOWNKey2KeyReportArchived } from './LVOWN Key2Key Report';
import { RSAKey2KeyReportArchived } from './RSA Key2Key Report';
import { ZurichCSIReportArchived } from './Zurich CSI Report';
import { CoreMIReportArchived } from './Core MI Report';
import { VolumeTrendsReportArchived } from './VolumeTrendsReport';
import { MonthlyNotificationVolumeArchived } from './MonthlyNotificationVolume';
import { CombinedNpsSmsEmailBillingReportArchived } from './CombinedNpsSmsEmailBilling Report';
import { EmailReportArchived } from './Email Report';
import { WPSiteConnectionsReportArchived } from './WPSiteConnectionsReport';

type ReportViewerParams = {
  reportPath: string;
};

function ReportNotFound() {
  return (
    <MainContainer direction="column">
      <Container direction="column">
        <GridItem>
          <Container>
            <BackButton text="Back to Reports" />
          </Container>
        </GridItem>
        <PageHeader>
          <Heading>Not found</Heading>
        </PageHeader>
        <GridItem>
          <Label>No report found, please try again.</Label>
        </GridItem>
      </Container>
    </MainContainer>
  );
}

export function ReportsDetailsOld() {
  const { reportPath } = useParams<ReportViewerParams>();
  const CurrentReport = generateReportTitle(reportPath || '');
  const [message, setMessage] = useState<string>('');
  const [isOpenToast, setIsOpenToast] = useState<boolean>(false);
  return (
    <>
      <CurrentReport.component
        reportPath={reportPath || ''}
        setErrorMessage={(data: string) => setMessage(data)}
        setToast={(data: boolean) => setIsOpenToast(data)}
      />
      <PrimaryToast
        message={message}
        isOpen={isOpenToast}
        onClose={() => setIsOpenToast(false)}
        severity="error"
      />
    </>
  );

  function generateReportTitle(report: string) {
    switch (report) {
      case 'GetRepairStatusReportCovea': {
        return { title: 'Repair Status Portal Usage', component: CoveaReportArchived };
      }
      case 'GetNPSBillingReport': {
        return { title: 'NPS Billing Report', component: NPSBilling };
      }
      case 'GetTLEngineeringSchedule': {
        return {
          title: 'TL Engineering Schedule Report',
          component: TotalLossArchived,
        };
      }
      case 'GetDLGoodwillReport': {
        return {
          title: 'DL Proposed Goodwill Report',
          component: GoodWillReportArchived,
        };
      }
      case 'GetInvoiceExtractReport': {
        return { title: 'Invoice Extract Report', component: InvoiceExtractArchived };
      }
      case 'GetSLAPerformanceV3Report': {
        return {
          title: 'SLA Performance V3 Report',
          component: SLAPerformanceV3Archived,
        };
      }
      case 'GetDetailedCycleTimeReportExV2': {
        return {
          title: 'Detailed Cycle Time Report with Exceptions',
          component: DetailedCycleTimeReportArchived,
        };
      }
      case 'GetSMSReport': {
        return { title: 'SMS Report', component: SMSReportArchived };
      }
      case 'Rolling30DayReport': {
        return {
          title: 'Repairer Capacity Report',
          component: Rolling30DayReportArchived,
        };
      }
      case 'GetWorkInProgressV3Report': {
        return {
          title: 'Work In Progress V3 Report',
          component: WorkInProgressArchived,
        };
      }
      case 'SMSBillingReport02': {
        return {
          title: 'SMS Billing Report - 02',
          component: SMSBillingReport,
        };
      }
      case 'GetB2BRestQueueMessages': {
        return {
          title: 'B2B Rest Queue Messages',
          component: B2BRestMessagesReportArchived,
        };
      }
      case 'GetVehiclesOnSite': {
        return {
          title: 'Vehicles On Site',
          component: VehiclesOnSiteArchived,
        };
      }
      case 'GetNARGControlSheetV05': {
        return {
          title: 'Narg Control Sheet V5',
          component: NargControlSheetV5Archived,
        };
      }
      case 'GetNPSSummaryReportV04': {
        return {
          title: 'NPS Summary Report V4',
          component: NPSSummaryReportArchived,
        };
      }
      case 'GetNPSDetailReportV04': {
        return {
          title: 'NPS Detail Report V4',
          component: NPSDetailV4Archived,
        };
      }
      case 'ActiveWebUsage01': {
        return {
          title: 'Activeweb Usage Report V2',
          component: ActiveWebUsageV2Archived,
        };
      }
      case 'GetAllSiteConnections': {
        return {
          title: 'All Sites Connections',
          component: AllSitesConnectionReportArchived,
        };
      }
      case 'GetFeedbackReport': {
        return {
          title: 'Feedback Report',
          component: FeedbackReportArchived,
        };
      }
      case 'GetKey2KeyDataForLVOWN': {
        return {
          title: 'LVOWN Key2Key Report',
          component: LVOWNKey2KeyReportArchived,
        };
      }
      case 'GetKey2KeyDataForRSA': {
        return {
          title: 'RSA Key2Key Report',
          component: RSAKey2KeyReportArchived,
        };
      }
      case 'GetCSITriggerReport': {
        return {
          title: 'CSI Trigger Report',
          component: ZurichCSIReportArchived,
        };
      }
      case 'GetCoreMIReport': {
        return {
          title: 'Core MI Report',
          component: CoreMIReportArchived,
        };
      }
      case 'GetVolumeTrendsReport': {
        return {
          title: 'Volume Trends Report',
          component: VolumeTrendsReportArchived,
        }
      }
      case 'GetMonthlyNotificationVolume': {
        return {
          title: 'Monthly Notification Volume Report',
          component: MonthlyNotificationVolumeArchived,
        }
      }
      case 'GetCombinedBillingReport': {
        return {
          title: 'Combined NPS, SMS and Email Billing Report',
          component: CombinedNpsSmsEmailBillingReportArchived,
        }
      }
      
      case 'GetEmailReport': {
        return {
          title: 'Email Report',
          component: EmailReportArchived,
        }
      }

      case 'GetWPSiteConnections': {
        return {
          title: 'WP Site Connections Report',
          component: WPSiteConnectionsReportArchived
        }
      }
      
      default: {
        return { title: 'Report not found', component: ReportNotFound };
      }
    }
  }
}

const MainContainer = styled(UpperInfoContainer)`
  padding: ${({ theme }) => `0 ${theme.padding.xl}`};
`;
